/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { OnboardingStatus } from '@accounts/types/onboarding';
import { type AuthenticationError } from '@accounts/types/store';

type Onboarding = {
    status: OnboardingStatus | undefined;
    error: AuthenticationError | undefined;
};

type OnboardingState = {
    onboarding: Onboarding;
};

export const initialState: Onboarding = {
    status: undefined,
    error: undefined
};

const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {
        setOnboardingStatus(state, action: PayloadAction<Onboarding['status']>) {
            state.status = action.payload;
        },
        setOnboardingError(state, action: PayloadAction<Onboarding['error']>) {
            state.error = action.payload;
        }
    }
});

export const { setOnboardingStatus, setOnboardingError } = onboardingSlice.actions;

export default onboardingSlice.reducer;

// Selectors
export const getOnboardingStatus = (state: OnboardingState): OnboardingStatus | undefined =>
    state.onboarding.status;
export const getOnboardingError = (state: OnboardingState): AuthenticationError | undefined =>
    state.onboarding.error;
